import React, {Fragment} from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Explanation_text from './Explanation_text';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import Draggable from 'react-draggable';
import Paper from '@material-ui/core/Paper';


const useStyles = makeStyles((theme) => ({
  container: {
    display:'flex',
    justifyContent:(props) =>(props.align=='right')?'flex-end':'center'
  },
  root:{

  },
  paper:{
    margin:'0px',
    height:(props)=> props.height,
    width:(props)=> props.width,
    maxWidth:(props)=> props.maxWidth,
    maxHeight:(props)=> props.maxHeight
  }
}));



const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    position:'relative'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '0px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(false);
  const classes=useStyles(props);

  const handleClickOpen = () => {
    setOpen(true);
    if(props.onOpen!=undefined){props.onOpen();}
  };
  const handleClose = () => {
    if(props.closed!=undefined){props.closed();}
    setOpen(false);
  };

  return (
    <Fragment>
      {(props.always_open==true)?null:(props.button_variant=='icon_button')?<IconButton onClick={handleClickOpen}>{props.button}</IconButton>:(props.button_variant=='none')?<div onClick={handleClickOpen}>{props.button}</div>:<Button variant={(props.button_variant!=undefined)?props.button_variant:"outlined"} color="primary" onClick={handleClickOpen}>{props.button}</Button>}
      <Dialog
          classes={{container:classes.container, root:classes.root, paper:classes.paper}}
          onClose={(props.handleClose==undefined)?handleClose:props.handleClose}
          aria-labelledby="customized-dialog-title" open={(props.always_open==true)?true:open}
          >
        <DialogTitle id="customized-dialog-title" onClose={(props.handleClose==undefined)?handleClose:props.handleClose} style={{position:'relative'}}>
          <span style={{position:'absolute'}}>{props.icon}</span>
          <span style={{marginLeft:(props.icon==undefined)?'0px':'50px', marginTop:'-10px', marginBottom:'-20px'}}>{(props.force_title==true)?props.title:<Explanation_text inline text={props.title}/>}</span>
        </DialogTitle>
        <DialogContent id='outer_scroll' dividers>
          {props.content}
        </DialogContent>
        {(props.accept_button==undefined && props.secondary_accept_button==undefined && props.tertiary_accept_button==undefined)?null:<DialogActions>
          {(props.onDelete==undefined)?null:
            <IconButton style={{position:'absolute', left:'10px'}} onClick={(e)=>{props.onDelete(); if(props.delete_no_close!=true){handleClose(e);}}}><DeleteIcon style={{color:'red', cursor:'pointer'}}/></IconButton>
          }
          {(props.tertiary_accept_button==undefined)?null:
            <span style={{width:(props.tertiary_accept_button_left==true)?'':undefined, position:(props.tertiary_accept_button_left==true)?'absolute':'relative', left:(props.tertiary_accept_button_left==true)?'10px':'', display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Button autoFocus type={undefined} onClick={(e)=>{if(props.tertiary_accept_button_click!=undefined){props.tertiary_accept_button_click();}}} variant='contained' color={(props.tertiary_accept_button_color==undefined)?"primary":props.tertiary_accept_button_color}>
            {props.tertiary_accept_button}
            <span style={{marginLeft:'20px'}}>{props.tertiary_accept_button_icon}</span>
          </Button></span>}
          
          {(props.secondary_accept_button==undefined)?null:
            <span style={{width:undefined, display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Button autoFocus type={undefined} onClick={(e)=>{if(props.secondary_accept_button_click!=undefined){props.secondary_accept_button_click();} if(props.no_close!=true){handleClose(e);}}} variant='contained' color={(props.secondary_accept_button_color==undefined)?"primary":props.secondary_accept_button_color}>
            {props.secondary_accept_button}
            <span style={{marginLeft:'20px'}}>{props.secondary_accept_button_icon}</span>
          </Button></span>}
          {(props.accept_button==undefined)?null:<Button autoFocus disabled={props.accept_button_disabled} type={(props.submit_button==true)?'submit':undefined} onClick={(e)=>{if(props.accept_button_click!=undefined){props.accept_button_click();} if(props.no_close!=true && props.submit_button!=true){handleClose(e);}}} variant='contained' color={(props.accept_button_color==undefined)?"primary":props.accept_button_color}>
            {props.accept_button}
            <span style={{marginLeft:'20px'}}>{props.accept_button_icon}</span>
          </Button>}
        </DialogActions>}
      </Dialog>
    </Fragment>
  );
}
